import { CTACard } from '@/components/CTACard';

import Replace from '@/public/img/strapi/technician-installing.webp';

type ReplaceCTAProps = {
	testId?: string;
	showImage: boolean;
};

const ReplaceCTA = (props: ReplaceCTAProps) => {
	const { testId = 'ReplaceCTA', showImage } = props;

	return (
		<CTACard
			testId={testId}
			type="link"
			compact
			color="hvac"
			href="/quote/"
			isStrapiInlineComponent
		>
			{showImage && (
				<div className="hidden h-44 w-60 overflow-hidden rounded-l-3xl lg:flex xl:w-70">
					<CTACard.Image
						src={Replace}
						alt="HVAC.com Replacement"
						className="min-h-full object-cover"
					/>
				</div>
			)}
			<div className="flex-1 px-6 py-4">
				<div className="flex justify-between gap-1">
					<CTACard.Badge
						color="pink"
						compact
						className="mb-2 whitespace-nowrap"
					>
						HVAC.com Replacement
					</CTACard.Badge>
				</div>
				<CTACard.Title compact className="pb-0.5">
					Replace your HVAC
				</CTACard.Title>
				<CTACard.Content compact isStrapiInlineComponent className="pb-2">
					Get a customized solution for your home with upfront pricing.
				</CTACard.Content>
				<CTACard.Action color="hvac" compact>
					See how it works
				</CTACard.Action>
			</div>
		</CTACard>
	);
};

export default ReplaceCTA;
